import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class InvoiceAdjustmentType extends DexResourceModel {

    @Field(String)
    public flDocumentCode: String = '';

    @Field(String)
    public flDocumentDescription: String | null = null;

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
